import "./polyfills";
import { initSentry } from "@utils/sentry";
import { setupLogger } from "@utils/logger";

initSentry();
// Initialize logger before anything else
setupLogger();

const { deviceRuntime: runtime } = require("./runtime/root");

const { setupAudioPro } = require("./utils/player/audio/audioProSetup");
setupAudioPro(runtime.player);

require("expo-router/entry");
